import styled from 'styled-components';

import { SkeletonElement } from '@notino/react-styleguide-v20';

import { StyledCenteredDiv } from '@styles/generalStyles';

export const SkeletonWrapper = styled(StyledCenteredDiv)`
  margin-top: 4rem;
  flex-direction: column;
`;
export const CircleSkeleton = styled(SkeletonElement)`
  height: 4rem;
  width: 4rem;
  border-radius: 50%;
`;

export const TitleSkeleton = styled(SkeletonElement)`
  height: 1.5rem;
  width: 20rem;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
`;

export const MessageSkeleton = styled(SkeletonElement)<{ width: number }>`
  height: 0.875rem;
  margin-bottom: 0.5rem;
  width: ${({ width }) => width}rem;
`;
